import { DocumentItem, FileItem } from "../../../models/polymer/Document.model";
import FileSelectionSegment from "../segments/file-selection-segment";
import { Separator } from "../../../components/separator";
import { Helpers } from "../../../utils/helper";
import {
  Dispatch,
  Fragment,
  SetStateAction,
  useCallback,
  useEffect,
  useState,
} from "react";
import { reduce, uniq } from "lodash";
import { P2Alert, P2Modal } from "react-bootstrap-common-script";
import { UploadFileType } from "../../../models/enum/upload-file-type.enum";
import { SolicitorCorrespondenceAdditionalInfo } from "../../../models/classes/solicitor/SolicitorCorrespondenceRequest.class";
import { PolymerAxios } from "../../../utils/axios";
import { API_Application } from "../../../utils/api";

interface DocumentationListsProps {
  document_list: DocumentItem[];
  filesItemsStorage?: FileItem[];
  setFileItemsStorage?: (files: FileItem[]) => void;
  type: UploadFileType;
  folderName?: string;
  defaultCheckboxList?: string[];
  setParentFormValid?: React.Dispatch<React.SetStateAction<boolean>>;
  getAdditionalCheckbox?: (additionalCheckbox: string[]) => void;
  forceError?: boolean;
  additionalInfo?: SolicitorCorrespondenceAdditionalInfo;
  createHandleAdditionalInfo?: (
    key: keyof SolicitorCorrespondenceAdditionalInfo
  ) => (value: string) => void;
  hdbRef?: string;
  uinfin?: string;
  singpassToken?: string;
  applicationId?: string;
}

function DocumentationLists({
  folderName,
  type,
  filesItemsStorage = [],
  document_list = [],
  defaultCheckboxList = [],
  setFileItemsStorage,
  additionalInfo,
  createHandleAdditionalInfo,
  forceError,
  hdbRef,
  uinfin,
  singpassToken,
  applicationId,
  ...props
}: DocumentationListsProps) {
  const [additionalCheckbox, setAdditionalCheckbox] =
    useState<string[]>(defaultCheckboxList);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [messageSize, setMessageSize] = useState<"5MB" | "10MB">("10MB");

  const closeModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);
  const handleModalTrigger = (type: "5MB" | "10MB") => {
    setMessageSize(type);
    setIsModalOpen(true);
  };
  /**
   *
   * @param files files that has been selected to upload.
   * @param code documentation code
   * @description to check new incoming and existing files has exceeded certain size.
   * @returns
   */
  const checkSelectedFilesSize = useCallback(
    (files: FileList | null, code: string, label: string) => {
      let storageFiles = filesItemsStorage.filter(
        (e) => e.code === code && e.label === label
      );

      let totalSize = reduce(
        storageFiles.map((e) => e.file_content.size),
        (sum, n: any) => {
          return sum + n;
        },
        0
      );

      const fileLength = files?.length ?? 0;
      if (files) {
        for (let i = 0; i < fileLength; i++) {
          let fileContent: File = files[i];
          totalSize += fileContent.size;
        }
      }

      return Helpers.isBytesExceed(totalSize, 10000000);
    },
    [filesItemsStorage]
  );

  /**
   *
   * @param event files that has been selected to upload.
   * @param code documentation code
   * @function handleFileChange
   * @description handle the files whenever the user select files to upload, process it and store into the filesItemsStorage state
   * @returns
   */
  const handleFileChange = useCallback(
    (
      event: React.ChangeEvent<HTMLInputElement>,
      code: string,
      label: string,
      file?: File
    ) => {
      const { files } = event.target;
      if (!files || files.length === 0) return; // early return

      // If fail file size check, skip
      if (checkSelectedFilesSize(files, code, label)) {
        handleModalTrigger("10MB");
        return;
      }

      const fileItems: FileItem[] = [...filesItemsStorage];
      // Note: The loop handles multiple files since the input has the 'multiple' attribute.
      // It's unclear if multiple file selection is required, but this approach is non-intrusive,
      // so 'multiple' is kept even though the function currently processes files one at a time.
      // Loop filelist from event object
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        console.log("handleFileChange processing: ", file);

        // Check individual file size
        if (Helpers.isBytesExceed(file.size, 5000000)) {
          handleModalTrigger("5MB");
          continue; // doesnt upload if exceed
        }

        // Create a File object
        const fileItemObj = new FileItem({
          code: code,
          label: label,
          file: file,
        });

        // Add in additional meta data
        fileItemObj.setFileInfo(file);

        // Create a FileReader
        const reader = new FileReader();
        reader.readAsDataURL(file);

        // When reader is done
        reader.onload = () => {
          const { result } = reader;
          // Get base64 from the result
          let base64 = Helpers.stripBase64(result?.toString()) ?? "";

          // Add base64 data to file
          fileItemObj.setFileBase64(base64);

          // At this point, file_id is undefined until API upload succeeds which will use assignFileFields() callback
          // *NOTE file_id !== file_content.id
          console.log("handleFileChange result: ", fileItemObj);
          fileItems.push(fileItemObj);
          setFileItemsStorage?.(fileItems);
        };
      }
      //   const fileLength = files?.length ?? 0;
      //   const fileItems : FileItem[] = [...filesItemsStorage]

      //   console.log("files",files)

      //   if (files && !checkSelectedFilesSize(files, code, label) ) {
      //     for (let i = 0; i < fileLength; i++) {
      //       let fileContent: File = files[i];
      //       console.log("fileContent",fileContent)

      //       if (Helpers.isBytesExceed(fileContent.size, 5000000)) {
      //         handleModalTrigger("5MB");
      //       } else {
      //         let fileItemObj = new FileItem({
      //           code: code,
      //           label: label,
      //           file: file,
      //         });
      //         fileItemObj.setFileInfo(fileContent);
      //         console.log('file: ',file)
      //         console.log('f: ',file)

      //         const reader = new FileReader();
      //         reader.readAsDataURL(fileContent);
      //         reader.onload = () => {
      //           console.log("fileItems Before",fileItems)
      //           const { result } = reader;
      //           let base64 = Helpers.stripBase64(result?.toString()) ?? "";
      //           fileItemObj.setFileBase64(base64);
      //           fileItems.push(fileItemObj)
      //           console.log("fileItems After",fileItems)
      //           setFileItemsStorage?.(fileItems);
      //         };
      //       }
      //     }
      //   } else {
      //     handleModalTrigger("10MB");
      //   }
    },
    [filesItemsStorage, checkSelectedFilesSize, setFileItemsStorage]
  );

  // triggers when file API upload succeeds
  const assignFileFields = useCallback(
    (file_id: string, submitted_date: string, key: string, id: string) => {
      let existingFiles = [...filesItemsStorage]; // make a copy
      console.log("assignFileFields triggered ", existingFiles);
      // Find the existing file
      let index = existingFiles.findIndex(
        (item) => item.file_content.id === id
      );

      if (index === -1) return; // exit if file not found

      let newObj = new FileItem(existingFiles[index]);

      // Set the return data from API to the file
      newObj.setKey(key);
      newObj.setSubmittedDate(submitted_date);
      newObj.setFileId(file_id);

      existingFiles[index] = newObj;
      console.log("assignFileFields updated ", existingFiles);
      setFileItemsStorage?.(existingFiles);
    },
    [filesItemsStorage, setFileItemsStorage]
  );

  /**
   * @param id id will be the ID of the each file.
   * @function clearFileChange
   * @description handle the files on which to delete from filesItemsStorage
   * @returns
   */
  const clearFileChange = useCallback(
    async (id: string) => {
      let existingFiles = [...filesItemsStorage]; // Use a copy
      let index = existingFiles.findIndex((e) => e.file_content.id === id);
      console.log("applicationId",applicationId)
      console.log("uin",uinfin)
      console.log("singpass",singpassToken)
      if (index === -1) return; // Nothing to remove; Early return

      const fileToRemove = existingFiles[index];

      try {
        const errorData = {
          // Log file removal
          action: "file_removal",
          file_id: fileToRemove.file_content.id, // The UUID generated during upload
          file_uuid: fileToRemove.file_id, // The file ID from upload response (crypto.randomUUID())
          file_details: {
            id: fileToRemove.file_content.id,
            name: fileToRemove.file_content.file_name,
            size: fileToRemove.file_content.size,
            document_type: fileToRemove.file_content.document_type,
            file_id: fileToRemove.file_id,
            key: fileToRemove.key,
            submitted_date: fileToRemove.submitted_date,
            code: fileToRemove.code,
            label: fileToRemove.label,
          },
          document_context: {
            total_files_before_removal: existingFiles.length,
            upload_type: type,
            folder_name: folderName,
          },
        };
        console.log(errorData);

        // Only try to delete in DB if file_id exist, means already upload
        if (fileToRemove.file_id) {
          await PolymerAxios(uinfin ?? '', singpassToken ?? '').post(
            `${API_Application}/${applicationId}/documents/${fileToRemove.file_id}/deletion-request`
          );
        }

        const updatedFiles = existingFiles.filter(
          (e: FileItem) => e.file_content.id !== id
        );
        console.log("updatedFiles: ", updatedFiles);
        setFileItemsStorage?.(updatedFiles);
      } catch (error) {
        console.error("Error clearing file change:", error);
      }
    },
    [filesItemsStorage]
  );

  const assignError = useCallback(
    (isError: boolean, id: string) => {
      let existingFiles = [...filesItemsStorage];
      let index = existingFiles.findIndex(
        (item) => item.file_content.id === id
      );
      if (index !== -1) {
        existingFiles[index].setIsError(isError);
      }
      setFileItemsStorage?.(existingFiles);
    },
    [filesItemsStorage]
  );

  const checkboxClick = useCallback(
    (label: string) => {
      let existing_document = additionalCheckbox;
      let found_index = existing_document.findIndex((e) => e === label);
      if (found_index === -1) {
        existing_document.push(label);
      } else {
        existing_document.splice(found_index, 1);
      }
      setAdditionalCheckbox([...existing_document]);
      if (props.getAdditionalCheckbox) {
        props.getAdditionalCheckbox(additionalCheckbox);
      }

      const cloned_file_items_storage = [...filesItemsStorage];
      setFileItemsStorage?.(
        cloned_file_items_storage.filter((item) => item.label !== label)
      );
    },
    [additionalCheckbox, filesItemsStorage]
  );

  /**
   * Perform validation check whether all the required documentation are uploaded.
   * How : get the unique codes from document_list that are required to upload, then check the unique code from fileItemsStorage. If all codes presented from uploaded_docs compare to required_docs, then valid.
   */
  const performValidityCheck = useCallback(() => {
    let required_docs = uniq(document_list.map((item) => item.label));
    let uploaded_docs = uniq(
      filesItemsStorage.filter((item) => item.file_id).map((item) => item.label)
    );

    let status = required_docs.every((e) => {
      if (uploaded_docs.includes(e) || additionalCheckbox.includes(e)) {
        return true;
      } else {
        return false;
      }
    });

    if (status) {
      status = filesItemsStorage.every((item) => item.file_id !== "");
    }

    if (props.setParentFormValid) {
      props.setParentFormValid(status);
    }
  }, [document_list, filesItemsStorage, props, additionalCheckbox]);

  useEffect(() => {
    performValidityCheck();
  }, [filesItemsStorage, additionalCheckbox, performValidityCheck]);

  const modalMessage =
    messageSize === "10MB"
      ? `You have now exceeded the maximum of 10MB worth of files. Please select another file or reduce the file size.`
      : `You have exceeded the maximum file size of 5MB. Please select another file or reduce the file size.`;

  return (
    <div>
      {document_list.map((document: DocumentItem, _index: number) => {
        const files = filesItemsStorage.filter(
          (file) => file.label === document.label && file.code === document.code
        );
        const key = _index;
        return (
          <Fragment key={key}>
            {key >= 1 && (
              <div className="polymer-documentation-list__separator">
                <Separator />
              </div>
            )}
            <FileSelectionSegment
              type={type}
              folderName={folderName}
              index={key}
              document={document}
              files={files}
              clearFileChange={clearFileChange}
              handleFileChange={handleFileChange}
              assignFileFields={assignFileFields}
              assignError={assignError}
              additionalCheckbox={additionalCheckbox}
              additionalCheckboxOnClick={checkboxClick}
              additionalInfo={additionalInfo}
              createHandleAdditionalInfo={createHandleAdditionalInfo}
            />
            {forceError &&
              (files.length === 0 || files.some((item) => !item.file_id)) && (
                <div style={{ marginTop: 24 }}>
                  <P2Alert
                    variant={"danger"}
                    text={"Please ensure files are uploaded successfully."}
                  ></P2Alert>
                </div>
              )}
          </Fragment>
        );
      })}
      <div className="polymer-small-width">
        <P2Modal
          isOpen={isModalOpen}
          onCloseModal={closeModal}
          variant="close-button"
          title="Maximum file size limit exceeded"
          children={<p>{modalMessage}</p>}
        />
      </div>
    </div>
  );
}

export default DocumentationLists;
